import React, { useEffect, useState } from "react";
import { GraduationCap, Lightbulb, BookOpen, AlertTriangle, Target, HelpCircle } from "lucide-react";
import { getDailyLesson } from "../services/lessons";
import { Badge, Skeleton } from "../components/common/Card";
import Reveal from "../components/common/Reveal";

export default function DailyLesson() {
  const [lesson, setLesson] = useState(null);
  useEffect(() => { getDailyLesson().then(setLesson).catch(() => {}); }, []);

  if (!lesson) {
    return (
      <div className="mx-auto max-w-3xl">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="mt-6 h-40 w-full" />
        <Skeleton className="mt-4 h-40 w-full" />
      </div>
    );
  }

  const sections = [
    { icon: BookOpen, label: "Main Lesson", body: lesson.body },
    { icon: Lightbulb, label: "Practical Example", body: lesson.example },
    { icon: AlertTriangle, label: "Risk Reminder", body: lesson.risk, tone: true },
    { icon: Target, label: "Action For Today", body: lesson.action },
    { icon: HelpCircle, label: "Reflection Question", body: lesson.reflection },
  ];

  return (
    <div className="mx-auto max-w-3xl">
      <Reveal>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-neutral-500">
            <GraduationCap size={14} /> Daily AI Lesson
          </div>
          <Badge tone="demo">{lesson.date}</Badge>
        </div>
        <h1 className="mt-4 font-head text-3xl font-extrabold uppercase leading-[1] tracking-tight text-white md:text-4xl">{lesson.title}</h1>
        <p className="mt-5 text-lg font-light leading-relaxed text-neutral-300">{lesson.intro}</p>
      </Reveal>

      <div className="mt-10 space-y-8">
        {sections.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.05}>
            <article className="border-l border-white/10 pl-6">
              <div className={`mb-3 flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest ${s.tone ? "text-amber-300/80" : "text-neutral-500"}`}>
                <s.icon size={13} /> {s.label}
              </div>
              <p className={`leading-relaxed ${s.tone ? "text-amber-100/70" : "text-neutral-300"}`}>{s.body}</p>
            </article>
          </Reveal>
        ))}
      </div>

    </div>
  );
}
